document.addEventListener('DOMContentLoaded', function() {

    // Moving this to Vue for Add to Cart stuff
    return;

    const $numberInputs = document.querySelectorAll('input[type="number"]');

    $numberInputs.forEach($numberInput => {
        const decreaseBtn = document.createElement('button');
        decreaseBtn.type = 'button';
        decreaseBtn.textContent = '-';
        decreaseBtn.classList.add('number-decrease');
        decreaseBtn.addEventListener('click', () => {
            const currentValue = parseInt($numberInput.value, 10);
            $numberInput.value = currentValue > 0 ? currentValue - 1 : 0;
            $numberInput.quantity = $numberInput.value;
        });

        const increaseBtn = document.createElement('button');
        increaseBtn.type = 'button';
        increaseBtn.textContent = '+';
        increaseBtn.classList.add('number-increase');
        increaseBtn.addEventListener('click', () => {
            const currentValue = parseInt($numberInput.value, 10);
            $numberInput.value = currentValue + 1;
            $numberInput.quantity = $numberInput.value;
        });

        $numberInput.parentNode.insertBefore(decreaseBtn, $numberInput);
        $numberInput.parentNode.insertBefore(increaseBtn, $numberInput.nextSibling);
    });
});
